<template>
  <div>
    <div class="main">
      <BackButton />
      <div class="shopping-cart">
        <h1 style="font-weight: bold">Shopping Cart</h1>
        <h3>You can change quantity at checkout.</h3>
        <div class="emptyCart" v-if="VuexCartItem.length === 0">
          <p style="color: #ffffff">
            Cart is empty! Go to
            <a href="#">
              <router-link to="/rentals" active-lass="active">
                <a style="font-size: 25px; color: orange">&nbsp;SHOP&nbsp;</a>
              </router-link>
            </a>
            to continue shopping.
          </p>
        </div>
        <div v-else>
          <!-- Loop enters -->
          <div class="table-responsive" style="margin: auto">
            <table class="table w-auto" style="width: 100%; color: #ffffff">
              <thead>
                <tr>
                  <th class="col">
                    <h3>Product</h3>
                  </th>
                  <th class="col"></th>
                  <th class="col">
                    <h3>Monthly Rental</h3>
                  </th>
                  <th class="col" style="width: 30%">
                    <h3>
                      Total Shipping
                      <span>
                        <small>(Delivery + Pick-up)</small>
                      </span>
                    </h3>
                  </th>
                  <th class="col">
                    <h3>Quantity</h3>
                  </th>
                  <th class="col">
                    <h3>Initial Payment</h3>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product, index) in VuexCartItem" :key="index">
                  <th>
                    <img
                      style="
                        display: block;
                        margin: auto;
                        width: 80%;
                        max-width: 300px;
                        border-radius: 10px;
                      "
                      class="image"
                      :src="product.image_url"
                      alt
                    />
                  </th>

                  <th>
                    <br />
                    <div class="description">
                      <h2 style="font-weight: bold">
                        {{ product.container_size }}
                      </h2>
                    </div>
                    <!-- DELETE BUTTON -->
                    <v-btn
                      class="btns"
                      min-width="80px"
                      color="red"
                      style="color: #ffffff"
                      @click="deleteAll()"
                      >Remove</v-btn
                    >
                    <!--END OF DELETE BUTTON -->
                  </th>
                  <!-- Monthly Price -->
                  <td>
                    <br />
                    <h3 class="unit-price">
                      ${{ formatNumber(product.container_price) }}
                    </h3>
                  </td>
                  <!-- Shipping Price -->
                  <td>
                    <br />
                    <h3>
                      ${{ formatNumber(product.hauling_price) }}
                      <span
                        href="#"
                        class="pa3 btn"
                        style="color: #00587d; padding: 0"
                        @click.stop="showDeliveryPopup = true"
                      >
                        <v-icon style="color: #ffffff">info</v-icon>
                      </span>
                      <br />

                      <v-dialog v-model="showDeliveryPopup" max-width="500px">
                        <div class="dialog">
                          <v-icon
                            @click="showDeliveryPopup = false"
                            style="border-radius: 0.8em; background: #6dbe45"
                            >close</v-icon
                          >
                          <h5>{{ deliveryInfoText }}</h5>
                        </div>
                      </v-dialog>
                    </h3>
                  </td>
                  <!-- Quantity -->
                  <td>
                    <br />
                    <number-input
                      :value="product.quantity"
                      :min="1"
                      :max="100"
                      @change="setQuantity(product.quantity, $event, index)"
                      size="small"
                      inline
                      center
                      controls
                      style="max-width: 110px; color: black"
                    ></number-input>
                  </td>

                  <td>
                    <br />
                    <h3 style="font-weight: bold">
                      ${{
                        formatNumber(product.total_price * product.quantity)
                      }}
                      <span
                        href="#"
                        class="pa3 btn"
                        style="color: #00587d; padding: 0"
                        @click.stop="showTotalPricePopup = true"
                      >
                        <v-icon style="color: #ffffff">info</v-icon>
                      </span>
                      <br />

                      <v-dialog v-model="showTotalPricePopup" max-width="500px">
                        <div class="dialog">
                          <v-icon
                            @click="showTotalPricePopup = false"
                            style="border-radius: 0.8em; background: #6dbe45"
                            >close</v-icon
                          >
                          <h5>{{ totalPriceInfoText }}</h5>
                        </div>
                      </v-dialog>
                    </h3>
                  </td>
                </tr>
              </tbody>
            </table>
            <hr />
          </div>
        </div>
      </div>
      <!-- Terms and Conditions starts-->
      <div class="row justify-content-center" v-if="VuexCartItem.length >= 1">
        <div
          class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3"
        >
          <div class="form-group">
            <label for="tnc">
              <input type="checkbox" id="TnC" v-model="bind_termsnconditions" />
              <span>
                &nbsp;Please confirm you accept our
                <a
                  style="color: #6dbe45"
                  href="https://westerncontainersales.com/about-shipping-containers/terms-conditions/"
                  target="_blank"
                  >&nbsp; terms & conditions &nbsp;</a
                >
                prior to placing your order.
              </span>
            </label>
          </div>
        </div>
      </div>
      <!-- Terms and Conditions ends-->
      <!-- Continue Button-->

      <div class="checkout">
        <v-btn
          :disabled="!VuexTermsConditions"
          color="#6dbe45"
          class="btns delivery_btn"
          style="color: #ffffff"
          @click="navigate()"
          v-if="VuexCartItem.length >= 1"
          >Proceed with Order<v-icon> mdi-arrow-right-thick </v-icon></v-btn
        >
        <!-- get quote button -->
        <v-btn
          @click="navigateQuoteSections()"
          color="#00587d"
          class="btns quote_btn"
          style="color: #ffffff"
          medium
          v-if="VuexCartItem.length >= 1"
          :disabled="!VuexTermsConditions"
          >Email Quote<v-icon> mdi-email-check </v-icon></v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { mapActions } from "vuex";
import * as types from "../store/types";
import BackButton from "./BackButton";

export default {
  name: "ShoppingCart",
  components: {
    BackButton,
  },
  computed: {
    //Store - vuex getters.
    ...mapGetters({
      VuexZipcode: types.ZIPCODE,
      VuexCartItem: types.CARTLINEITEM,
      VuexTermsConditions: types.TERMSNCONDITIONS,
    }),
    bind_termsnconditions: {
      get() {
        return this.VuexTermsConditions;
      },
      set(value) {
        this.setVuexTermsConditions(value);
        //Update the local storage with terms and conditions
        this.maintainSessionStorageCart();
      },
    },
  },
  mounted() {
    window.scrollTo(0, 0);
    this.getDeliveryInfo();
  },
  data() {
    return {
      showDeliveryPopup: false,
      deliveryInfoText: "",
      totalPrice: 0,
      totalPriceInfoText:
        "The initial payment includes delivery, pick-up, and the first month's rent. After that, only the monthly rental rate will be charged (plus applicable taxes).",
      showTotalPricePopup: false,
    };
  },
  methods: {
    //Store - vuex actions > mutations
    ...mapActions({
      deleteCartItem: types.ACTIONS_UPDATE_EMPTYCART,
      setVuexTermsConditions: types.ACTIONS_UPDATE_TERMSNCONDITIONS,
    }),
    navigateQuoteSections() {
      this.$router.push("/quote");
    },
    deleteAll() {
      //Delete the cart line item and update the local storage.
      this.deleteCartItem();
      this.maintainLocalStorageCart();
    },
    getDeliveryInfo() {
      this.deliveryInfoText =
        "Estimated price based on postal code: " +
        this.VuexZipcode +
        ". The delivery price will be recalculated at checkout when the full shipping address is provided.";
    },
    setQuantity(oldQuantity, newQuantity, index) {
      //update quanity, subtotal, total, LocalStorage Cart
      if (oldQuantity === newQuantity) return;
      this.VuexCartItem[index]["quantity"] = newQuantity;
      this.maintainLocalStorageCart();
    },
    formatNumber(num) {
      if (num % 1 === 0)
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      else return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
    },
    navigate() {
      this.$router.push("/rentals/cart/predeliveryQnA");
    },
    maintainLocalStorageCart() {
      //Maintaint local storage with cart line item.
      const cartItem = JSON.stringify(this.VuexCartItem);
      localStorage.setItem("cartItem", cartItem);
    },
    maintainSessionStorageCart() {
      //Maintain session storage with terms and conditions.
      const Terms_Conditions = JSON.stringify(this.VuexTermsConditions);
      sessionStorage.setItem("Terms_Conditions", Terms_Conditions);
    },
  },
};
</script>

<style scoped>
.main {
  margin: 0px auto;
  padding: 10px;
  width: 90%;
  text-align: center;
  border-radius: 25px;
  color: white;
  margin-bottom: 40px;
}

.btns {
  text-decoration: none;
  font-weight: 700;
  text-transform: unset !important;
  border-radius: 15px;
  margin: 5px;
}

.delivery_btn {
  box-shadow: 1px 1px 1px 1px #ffffff;
}

.btns i {
  max-width: 0;
  transition: max-width 0.5s;
  display: inline-block;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  margin-left: 10px;
}

.checkout button[class*="btn"] {
  display: inline-block;
  cursor: pointer;
  width: 220px;
  height: 40px;
  margin-bottom: 40px;
  margin-right: 20px;
}


.quote_btn {
  box-shadow: 1px 1px 1px 1px #6dbe45;
}

.btns:hover i {
  max-width: 15rem;
  transition-delay: 0.1s;
}

.theme--light.v-btn.v-btn--disabled:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  opacity: 0.6 !important;
  background-color: #ffffff !important;
}

.shopping-cart {
  text-align: center;
  margin: auto;
  width: 90%;
}

.col {
  width: 14%;
}

.description {
  color: #ffffff;
  font-weight: bold;
}

.total {
  text-align: right;
  font-weight: bolder;
  float: right;
  color: #ffffff;
}

.deletebutton button[class*="btn"] {
  padding-right: 10px;
  width: 0px;
  height: 0px;
  background-color: none;
  border-radius: none;
  cursor: pointer;
  border: none;
}

.emptyCart p {
  font-size: 25px;
  color: #121310;
}

.dialog {
  background-color: white;
  border-radius: 15px;
  padding: 15px;
}

a {
  font-size: 20px;
}

strong {
  font-size: 20px;
}

input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

table > thead > tr > th {
  border: 0;
}

hr {
  border: 1px solid rgb(222, 226, 230);
}

@media only screen and (max-width: 880px) {
  .image {
    max-width: 50px;
  }

  table {
    width: 80%;
  }

  /* Force table to not be like tables anymore */
  table,
  thead,
  tbody,
  th,
  td,
  tr {
    display: block;
  }

  /* Hide table headers (but not display: none;, for accessibility) */
  thead tr {
    position: absolute;
    top: -9999px;
    left: -9999px;
  }

  .row {
    text-align: center;
  }

  td {
    border: none;
    text-align: center;
    /* Behave  like a "row" */
    position: relative;
    padding-left: 50%;
  }

  td:before {
    /* Now like a table header */
    position: absolute;
    float: left;
    /* Top/left values mimic padding */
    top: 6px;
    left: 6px;
    width: 45%;
    padding-right: 10px;
    white-space: nowrap;
  }

  /*
Label the data
*/
  td:nth-of-type(1):before {
    content: "Monthly Rental";
  }
  td:nth-of-type(2):before {
    content: "Total Shipping \A (Delivery + Pick-up)";
  }
  td:nth-of-type(3):before {
    content: "Initial Payment";
  }
  th:nth-of-type(0) {
    border-width: 2px;
    border-color: rgb(128, 128, 128, 0.5);
  }
  td:nth-of-type(0) {
    border: none;
  }
}

@media only screen and (max-width: 880px) {
  h3,
  div,
  p,
  a,
  nav,
  v-btn,
  input,
  strong,
  h2 {
    font-size: 20px;
  }
}

@media only screen and (min-width: 880px) and (max-width: 1100px) {
  h3,
  div,
  p,
  a,
  nav,
  v-btn,
  input,
  strong,
  h2 {
    font-size: 11px;
  }
}

@media only screen and (min-width: 1100px) and (max-width: 1400px) {
  h3,
  v-btn,
  div,
  p,
  a,
  nav,
  input,
  strong,
  h2 {
    font-size: 18px;
  }
}

@media only screen and (min-width: 1400px) {
  h3,
  v-btn,
  div,
  p,
  a,
  nav,
  input,
  strong,
  h2 {
    font-size: 24px;
  }
}

@media screen and (max-width: 480px) {
  .main {
    width: 100%;
  }
}

@media screen and (max-width: 400px) {
  h3,
  v-btn,
  div,
  p,
  a,
  nav,
  input,
  strong,
  h2 {
    font-size: 15px;
  }
}
</style>
